import styled, { css } from 'styled-components';
import DefaultSelect from 'components/Form/Select';

const StatusSelect = styled(DefaultSelect)`
  float: right;

  &.MuiInputBase-root {
    border-radius: 1.5rem;
    padding: 0.75rem;
    height: 3rem;
    font-family: Gilroy;
    font-size: 1.0625rem;
    line-height: 1.5rem;
    font-weight: 500;
    width: fit-content;
    justify-self: flex-end;
  }

  .MuiSelect-select.MuiSelect-select {
    padding-right: 1.575rem;

    &:focus,
    &:active {
      background: inherit;
    }
  }

  .MuiSelect-icon {
    right: 1rem;
    top: 1rem;
    width: 1rem;
    height: 1rem;
  }

  ${({ value, theme }) => {
    switch (value) {
      case 'SUSPEND_DAY':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.yellowLight};
            color: ${theme.colors.yellowDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.yellowDark};
          }
        `;
      case 'ACTIVE':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.greenExtraLight};
            color: ${theme.colors.greenDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.greenDark};
          }
        `;
      default:
      case 'SUSPEND_INDEFINITE':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.redExtraLight};
            color: ${theme.colors.redDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.redDark};
          }
        `;
    }
  }}
`;

export default StatusSelect;
